/**
 * Wire-mapping for the tenant-wide audit-log query (OIDCPAM Gate-6 Phase 6d
 * — Audit.tsx -> @devnw/cyber-iam/authz/AuditQueryExplorer).
 *
 * `adminQueryAudit` returns the generator-typed `AdminQueryAuditResp` (see
 * gen/client/react/client.ts) — a concrete, schema-derived response type,
 * NOT an opaque `{}` — so its `records: Array<AuditRecord>` are already the
 * client's REAL camelCase fromWire() output (actorSub, pamRequestId,
 * catalogCode, sessionId, tenantId, ...), not the hand-written snake_case
 * `AuditEvent` shape in ../api/types.ts.
 *
 * LATENT BUG FIXED (Gate-6 shared-doc bug class): the pre-migration page
 * cast `result.records` straight to the snake_case `AuditEvent[]` via
 * `as unknown as` and read `actor_sub` / `pam_request_id` off it — both keys
 * are `undefined` on the real camelCase `AuditRecord` object, so the Actor
 * and PAM Request columns silently rendered "—" and the per-row evidence
 * deep-link never appeared, in production. This maps camelCase -> camelCase
 * field-for-field onto @devnw/cyber-iam's authz/types#AuditEvent shape.
 * `timestamp`/`event`/`outcome` are pre-formatted display strings the
 * library never parses — the wire already sends a display-ready RFC3339
 * timestamp, so it passes straight through unchanged (same "no new
 * formatting" precedent as accessRequestMapping.ts's toIamAccessRequest).
 */
import type { AuditRecord } from '@gen/react/client'
import type {
  AuditEvent as IamAuditEvent,
} from '@devnw/cyber-iam/iam/types'

export function toIamAuditEvent(r: AuditRecord): IamAuditEvent {
  return {
    id: r.id,
    timestamp: r.timestamp ?? '',
    event: r.event ?? '',
    actorSub: r.actorSub,
    resource: r.resource,
    outcome: r.outcome ?? '',
    pamRequestId: r.pamRequestId,
    jti: r.jti,
  }
}
